import React from "react";
import { IconCube } from "@tabler/icons-react";
import { InventoryProductDetailsByFileOut } from "api-client";
import clsx from "clsx";
import ProductChips from "features/BuildingProductEditor/components/ProductChips";
import { REFERENCE_UNITS } from "features/MappingEditor/consts";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import { getProductOrganisationName } from "utils/productDisplay";

const ImageHeader = ({
  imageURL,
  details,
  refUnit,
  ...props
}: {
  imageURL: string;
  details?: InventoryProductDetailsByFileOut | null;
  productName?: string | null;
  refUnit?: string;
}) => {
  const { i18n } = useTranslation();

  const getRefUnitName = () => {
    const currentRefUnit = REFERENCE_UNITS.find((item) => item.id === refUnit);
    return i18n.language === "en"
      ? currentRefUnit?.name
      : currentRefUnit?.name_de;
  };

  const diagramURL = details?.files_info?.diagrams?.[0]?.url;

  return (
    <div className="relative overflow-hidden">
      <img
        src={imageURL}
        alt={props?.productName as string}
        className="w-full h-[250px] object-cover blur-md mr-3"
      />
      <img
        src={imageURL}
        alt={props?.productName as string}
        className="absolute top-0 left-[50%] transform translate-x-[-50%] h-[250px] object-cover"
      />
      {diagramURL && (
        <img
          src={diagramURL}
          alt="diagram"
          className="absolute bottom-0 left-0 max-w-[112px] max-h-[112px] z-1"
        />
      )}
      <div className="z-0 from-gray-600 bg-gradient-to-t to-transparent absolute bottom-0 left-0 w-full h-[250px]"></div>
      <div
        className={clsx(
          "absolute flex bottom-0 left-0 p-6 items-center w-full max-w-fit pt-10 z-1",
          diagramURL ? "left-[112px]" : "left-0"
        )}
      >
        <IconCube
          stroke={3}
          className="bg-teal-300 rounded-full p-[6px] min-w-8 h-8 mr-2 text-teal-900"
        />
        <div>
          <ProductChips
            refUnit={getRefUnitName()}
            conformity={details?.compliance?.conformities}
            certifications={details?.compliance?.certifications}
            healthChecked={details?.health_checked}
            organisationName={getProductOrganisationName(
              details,
              sidebarMenuStore.currentOrganisation?.id
            )}
          />
          <div className="text-lg font-semibold text-white mt-2">
            {props?.productName}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(ImageHeader);
